import React, { useState, useEffect } from 'react';

import { Navigate } from 'react-router';

// Material Ui
import {
	Grid,
	Box,
	Typography,
	Button,
	Card,
	CardHeader,
	CardContent,
	CardActions,
	Link,
	TextField
} from '@mui/material';

import { Visibility, VisibilityOff } from '@mui/icons-material';
import { IconButton, InputAdornment } from '@mui/material';
import { useForm, Controller } from 'react-hook-form';
import { useQuery } from '../../utils/query';

export function ResetPasswordRequest({
	onInputChange,
	handleResetPassword,
	error,
	updateError,
	navigate
}) {
	const { handleSubmit } = useForm();
	const [disabledButton, setDisabledButton] = useState(true);

	useEffect(
		() => () => {
			updateError(null);
		},
		[updateError]
	);

	const onEmailValidate = (e) => {
		if (e.target.value.length > 8) {
			setDisabledButton(false);
		} else {
			setDisabledButton(true);
		}
	};

	return (
		<>
			<Typography fontWeight="bold" variant="h4">
				Doreşti să resetezi parola contului?
			</Typography>
			<Box>
				<Grid container>
					<form
						onSubmit={handleSubmit(() => {
							handleResetPassword();
						})}
					>
						<Grid container>
							<Typography fontSize="small">
								Vă rugăm să introduceți adresa de e-mail pentru a vă putea indentifica contul.
							</Typography>
							<Grid item xs={12} md={12} sx={{ marginTop: '15px' }}>
								<TextField
									label="Adresa de e-mail"
									name="email"
									type="email"
									required
									fullWidth
									margin="dense"
									inputProps={{
										autoComplete: 'email@example.com'
									}}
									onChange={(e) => {
										onInputChange(e);
										onEmailValidate(e);
									}}
								/>
								<Typography
									sx={{
										display: error ? 'block' : 'none',
										fontSize: 'small'
									}}
									variant="subtitle1"
									gutterBottom
									component="div"
									color="error"
								>
									{error || null}
								</Typography>
							</Grid>
						</Grid>
						<Grid container display="flex" justifyContent="end" sx={{ marginTop: '15px' }}>
							<Button variant="text" color="primary">
								<Link
									tabIndex={0}
									underline="none"
									variant="button"
									onKeyPress={() => {
										navigate(-1);
									}}
									onClick={() => {
										navigate(-1);
									}}
								>
									Inapoi
								</Link>
							</Button>
							<Button variant="contained" color="primary" type="submit" disabled={disabledButton}>
								Trimite e-mail
							</Button>
						</Grid>
					</form>
				</Grid>
			</Box>
		</>
	);
}

export function ResetPasswordUpdate({
	onInputChange,
	handleResetPasswordUpdate,
	updateError,
	error,
	isStatusMessage
}) {
	const [showPassword, setShowPassword] = useState(false);
	const { handleSubmit, control } = useForm();

	useEffect(
		() => () => {
			updateError(null);
		},
		[updateError]
	);

	const query = useQuery();

	if (!query.get('email')) {
		return <Navigate to="/login" />;
	}

	if (!query.get('code')) {
		return <Navigate to="/login" />;
	}

	const handleClickShowPassword = () => {
		setShowPassword(!showPassword);
	};

	const handleMouseDownPassword = (event) => {
		event.preventDefault();
	};

	const subtitle = (
		<ul
			style={{
				listStyleType: 'none',
				fontSize: 'small',
				padding: 0,
				marginBottom: 0
			}}
		>
			<li>Alege-ti noua ta parola!</li>
		</ul>
	);
	return (
		<>
			{!isStatusMessage ? (
				<Typography fontWeight="bold" variant="h4">
					Vrei sa iti resetezi parola?
				</Typography>
			) : null}
			<Box>
				<Grid container>
					<form
						onSubmit={handleSubmit(() => {
							handleResetPasswordUpdate(query.get('email'), query.get('code'));
						})}
					>
						<Grid container>
							<Typography fontSize="small">Alege-ti noua ta parola!</Typography>
							<Grid item xs={12}>
								<Controller
									control={control}
									name="Password"
									render={({ field: { onChange, onBlur, value, ref } }) => (
										<TextField
											required
											fullWidth
											name="password"
											label="Parola"
											type={showPassword ? 'text' : 'password'}
											id="password"
											InputProps={{
												endAdornment: (
													<InputAdornment position="end">
														<IconButton
															aria-label="toggle password visibility"
															onClick={handleClickShowPassword}
															onMouseDown={handleMouseDownPassword}
															edge="end"
														>
															{showPassword ? <Visibility /> : <VisibilityOff />}
														</IconButton>
													</InputAdornment>
												)
											}}
											onChange={onInputChange}
											margin="dense"
										/>
									)}
								/>
							</Grid>
							<Grid item xs={12}>
								<Controller
									control={control}
									name="repeatPassword"
									render={({ field: { onChange, onBlur, ref } }) => (
										<TextField
											required
											fullWidth
											name="confirmPassword"
											label="Confirma Parola"
											type={showPassword ? 'text' : 'password'}
											id="repeatPassword"
											InputProps={{
												endAdornment: (
													<InputAdornment position="end">
														<IconButton
															aria-label="toggle password visibility"
															onClick={handleClickShowPassword}
															onMouseDown={handleMouseDownPassword}
															edge="end"
														>
															{showPassword ? <Visibility /> : <VisibilityOff />}
														</IconButton>
													</InputAdornment>
												)
											}}
											onChange={onInputChange}
											margin="dense"
										/>
									)}
								/>
								<Typography
									sx={{
										display: error ? 'block' : 'none',
										fontSize: 'small'
									}}
									variant="subtitle1"
									gutterBottom
									component="div"
									color="error"
								>
									{error || null}
								</Typography>
							</Grid>
						</Grid>
						<Grid container display="flex" justifyContent="end" sx={{ marginTop: '15px' }}>
							<Button variant="contained" color="primary" type="submit">
								Reseteaza
							</Button>
						</Grid>
					</form>
				</Grid>
			</Box>
		</>
	);
}
